import { jsx as _jsx } from "react/jsx-runtime";
// import components
import IconButton from "@mui/material/IconButton";
import { Root, Icon } from "../../../components/atoms/IconButton/IconButton.components.js";
import Badge from "../../../components/atoms/Badge/index.js";
export const IconButtonAtomComponent = ({ type, iconProps, badge, variant = "text", color = "default", ...props }) => {
    const icon = _jsx(Icon, { "data-testid": "IconButtonIcon", ...iconProps, type: type, variant: variant, iconColor: color });
    return (_jsx(Root, { "data-testid": "IconButton", variant: variant, color: color, ...props, children: badge ? (_jsx(Badge, { "data-testid": "IconButtonBadge", ...badge, children: icon })) : (icon) }));
};
export const MuiIconButton = IconButton;
export default IconButtonAtomComponent;
